import {axiosInstance} from '../axiosInstance';

/** POST `/executor_web/identification/identity_verification` — подтверждение сверенных данных */
export function verifyIdentity(signal?: AbortSignal) {
	return axiosInstance.post<void>('identification/identity_verification', undefined, {signal});
}
